import { atom } from 'jotai';
import { chapterAtom, nextChapterAtom, prevChapterAtom } from './chaptersStore';
import { Pass1LearningPath, Pass2LearningPath, CareerMap } from '../typesV2';

// NEW STUFF

export const jobTitleAtom = atom<string | null>(null);
export const isStreamingMapAtom = atom(false);
export const streamMapErrorAtom = atom<Error | null>(null);
export const mapDataAtom = atom<CareerMap | null>(null);
export const newMapDataAtom = atom<any>(null);
export const pass1LearningPathAtom = atom<Pass1LearningPath | null>(null);
export const pass2LearningPathAtom = atom<Pass2LearningPath | null>(null);
export const isStreamingContentAtom = atom(false);
export const streamContentErrorAtom = atom<Error | null>(null);
export const overviewAtom = atom('');
export const contentAtom = atom('');
export const streamingContentSlugAtom = atom<string | null>('test'); 

export const isLoadingNavAtom = atom<boolean>(false);

// export const contentAtom = atom(
//   (get) => {
//     const currentMap = get(mapDataAtom);

//     const chapter = get(chapterAtom);
//     console.log('🚀 ~ chapter:', chapter);

//     if (!currentMap || chapter === null || chapter === undefined) {
//       return '';
//     }

//     if (chapter === 'overview') {
//       return currentMap.jobDescription || '';
//     }

//     const { subTopicIndex, topicIndex, sideQuestIndex } = chapter;

//     if (
//       subTopicIndex !== -1 &&
//       subTopicIndex !== null &&
//       topicIndex !== -1 &&
//       topicIndex !== null
//     ) {
//       if (!!subTopicIndex) {
//         if (currentMap.topicList[topicIndex]?.sections) {
//           const content =
//             currentMap.topicList[topicIndex]?.sections?.[subTopicIndex]
//               ?.content;
//           console.log('🚀 ~ contentAtom ~ content:', content);
//           return content || '';
//         }

//         if (currentMap.topicList[topicIndex]?.options) {
//           const content =
//             currentMap.topicList[topicIndex]?.options?.[subTopicIndex]?.content;
//           console.log('🚀 ~ contentAtom ~ content:', content);
//           return content || '';
//         }
//       }
//       if (!!sideQuestIndex) {
//         const content =
//           currentMap.topicList[topicIndex]?.sideQuests?.[sideQuestIndex]
//             ?.content;
//         console.log('🚀 ~ contentAtom ~ content:', content);
//         return content || '';
//       }
//     } else {
//       return currentMap.jobDescription || '';
//     }
//   },
//   (_get, set, newText?: string) => {
//     const currentMap = _get(mapDataAtom);

//     const chapter = _get(chapterAtom);
//     console.log('🚀 ~ chapter SETTING:', chapter);
//     if (
//       !currentMap ||
//       chapter === null ||
//       chapter === undefined ||
//       chapter === 'overview' ||
//       !newText
//     ) {
//       return;
//     }

//     if (chapter.type === 'overview') {
//       set(mapDataAtom, { ...currentMap, jobDescription: newText });
//     } else {
//       const { subtopicIndex, topicIndex } = chapter;
//       const activeTopic = currentMap.topicList[topicIndex];
//       if (!activeTopic) {
//         throw new Error('Active topic not found');
//       }
//       if (chapter.type === 'section' && activeTopic.sections) {
//         const updatedSubtopics = [...activeTopic.sections];
//         updatedSubtopics[subtopicIndex] = {
//           ...updatedSubtopics[subtopicIndex],
//           content: newText,
//         };
//         const updatedTopicList = [...currentMap.topicList];
//         updatedTopicList[topicIndex] = { ...currentMap.topicList[topicIndex], sections: updatedSubtopics };
//         set(mapDataAtom, { ...currentMap, topicList: updatedTopicList });
//       } else if (chapter.type === 'option') {
//         const updatedOptions = [...currentMap.topicList[chapter.topicIndex].options];
//         updatedOptions[chapter.subTopicIndex] = {
//           ...updatedOptions[chapter.subTopicIndex],
//           content: newText,
//         };
//         const updatedTopicList = [...currentMap.topicList];
//         updatedTopicList[chapter.topicIndex] = { ...currentMap.topicList[chapter.topicIndex], options: updatedOptions };
//       } else if (chapter.type === 'sidequest') {
//         const updatedSideQuests = [...currentMap.topicList[chapter.topicIndex].sideQuests];
//         updatedSideQuests[chapter.subTopicIndex] = {
//           ...updatedSideQuests[chapter.subTopicIndex],
//           content: newText,
//         };
//         const updatedTopicList = [...currentMap.topicList];
//         updatedTopicList[chapter.topicIndex] = { ...currentMap.topicList[chapter.topicIndex], sideQuests: updatedSideQuests };
//       }
//     }

//     if (chapter.type === 'section') {


//     if (subTopicIndex !== null && topicIndex !== null) {
//       console.log('🚀 ~ subTopicIndex !== null && topicIndex !== null');
//       const topic = currentMap.topicList[topicIndex];
//       // console.log('🚀 ~ contentAtom ~ topic:', topic);
//       if (topic?.sections && subTopicIndex !== null && subTopicIndex !== undefined) {
//         const updatedSubtopics = [...topic.sections];
//         updatedSubtopics[subTopicIndex] = {
//           ...updatedSubtopics[subTopicIndex],
//           content: newText,
//         };
//         const updatedTopicList = [...currentMap.topicList];
//         updatedTopicList[topicIndex] = {
//           ...topic,
//           sections: updatedSubtopics,
//         };
//         set(mapDataAtom, { ...currentMap, topicList: updatedTopicList });
//       }
//       if (topic?.options && subTopicIndex !== null && subTopicIndex !== undefined) {
//         // console.log('🚀 ~ contentAtom ~ topic?.options:', topic?.options);
//         const updatedOptions = [...topic.options];
//         updatedOptions[subTopicIndex] = {
//           ...updatedOptions[subTopicIndex],
//           content: newText,
//         };
//         const updatedTopicList = [...currentMap.topicList];
//         updatedTopicList[topicIndex] = { ...topic, options: updatedOptions };
//         set(mapDataAtom, { ...currentMap, topicList: updatedTopicList });
//       }
//     } else if (sideQuestIndex !== null && topicIndex !== null) {
//       console.log('🚀 ~ sideQuestIndex !== null && topicIndex !== null');
//       const topic = currentMap.topicList[topicIndex];
//       if (topic?.sideQuests && sideQuestIndex !== null && sideQuestIndex !== undefined) {
//         const updatedSideQuests = [...topic.sideQuests];
//         updatedSideQuests[sideQuestIndex] = {
//           ...updatedSideQuests[sideQuestIndex],
//           content: newText,
//         };
//         const updatedTopicList = [...currentMap.topicList];
//         updatedTopicList[topicIndex] = {
//           ...topic,
//           sideQuests: updatedSideQuests,
//         };
//         set(mapDataAtom, { ...currentMap, topicList: updatedTopicList });
//       }
//     } else {
//       set(mapDataAtom, { ...currentMap, jobDescription: newText });
//     }
//   }
// );

export const mobileSidebar = atom(false);
export const desktopSidebar = atom(true);
export const mapViewAtom = atom(false);

export const viewportAtom = atom({
  x: 0,
  y: 0,
  zoom: 1
});

export const chaptersOpenStatesAtom = atom<boolean[]>([true]);

// DERIVED ATOMS
export const isEitherStreamingAtom = atom((get) => {
  return get(isStreamingContentAtom) || get(isStreamingMapAtom);
});

// Add this near the end of the file, with the other derived atoms
export const applicationStateAtom = atom(
  (get) => {
    return {
      // Map related
      isStreamingMap: get(isStreamingMapAtom),
      streamMapError: get(streamMapErrorAtom),
      mapData: get(mapDataAtom),

      // Chapter related
      currentChapter: get(chapterAtom),
      nextChapter: get(nextChapterAtom),
      prevChapter: get(prevChapterAtom),
      chaptersOpenStates: get(chaptersOpenStatesAtom),

      // Content related
      isStreamingContent: get(isStreamingContentAtom),
      streamContentError: get(streamContentErrorAtom),
      content: get(contentAtom),

      // UI State
      mobileSidebar: get(mobileSidebar),
      desktopSidebar: get(desktopSidebar),
      mapView: get(mapViewAtom),

      // Derived states
      isEitherStreaming: get(isEitherStreamingAtom),
    };
  },
  (get, set) => {
    set(mapDataAtom, null);
    set(contentAtom, '');
    set(isStreamingContentAtom, false);
    set(streamContentErrorAtom, null);
    set(isStreamingMapAtom, false);
    set(streamMapErrorAtom, null);
  }
);
